import { render, staticRenderFns } from "./PlantChart.vue?vue&type=template&id=018fbac0&scoped=true"
import script from "./PlantChart.vue?vue&type=script&lang=js"
export * from "./PlantChart.vue?vue&type=script&lang=js"
import style0 from "./PlantChart.vue?vue&type=style&index=0&id=018fbac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018fbac0",
  null
  
)

export default component.exports